import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewEncapsulation } from "@angular/core";
import { PhxSelectValue } from "../select/select.types";
import { PhxTagType, PhxTagContrast } from '../tag/phx-tag.types';
import mixinDisabled from "../../mixins/disabled";
import { PhxTagSelectOption } from './phx-tag-select.types';
import { ChevronDown } from '../icon/icon-map';
import { defaultValues } from "../tag/phx-tag.component";

const baseButtonMixin = mixinDisabled(
  class {
    constructor() {}
  }
);

@Component({
  templateUrl: "./phx-tag-select.component.html",
  styleUrls: ["./phx-tag-select.component.scss"],
  selector: "phx-tag-select",
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush,
  host : {
    class: "phx-tag-select"
  },
  inputs: ['phxDisabled'],
})
export class PhxTagSelectComponent extends baseButtonMixin {
  @Input() public phxOptions: PhxTagSelectOption[] = [];
  @Input() public phxTagType: PhxTagType = defaultValues.tagType;
  @Input() public phxContrast: PhxTagContrast = defaultValues.contrast;
  @Input() public phxPlaceholder: string;
  @Input() public phxSelected: PhxSelectValue;

  @Output() public phxSelectedChange: EventEmitter<PhxSelectValue> = new EventEmitter<PhxSelectValue>();

  public selectedOptionLabel: string;
  public readonly ChevronDownIcon: string = ChevronDown;
}
